import './index.scss'

const READ_MESSAGE = 'read_service_platform_message'

export const AlertUpdateMessage = defineComponent({
  emits: ['close'],
  setup() {
    const updateMsg = useUpdateMessage()
    const showUpdateMessagesTip = useShowUpdateMessageTip()

    function getStoredData() {
      const storedInfo = localStorage.getItem(READ_MESSAGE)

      let storedJSONData = ''
      if (storedInfo) {
        storedJSONData = JSON.parse(storedInfo)
      }

      return storedJSONData
    }

    let readUpdateMsgId = getStoredData()

    function onClose() {
      readUpdateMsgId = updateMsg.value!.id + ''

      updateMsg.value = undefined

      localStorage.setItem(READ_MESSAGE, JSON.stringify(readUpdateMsgId))
    }

    const showMessage = computed(() => {
      if (`${updateMsg.value?.id}` === readUpdateMsgId) {
        return false
      }

      return showUpdateMessagesTip.value
    })

    return () => {
      if (!showMessage.value) {
        return null
      }

      const messageContent = () => (
        <div>{`${updateMsg.value!.stop_message_text}`}</div>
      )

      const children = {
        message: messageContent,
      }

      return (
        <a-alert
          class="message-alert message-alert-top"
          v-slots={children}
          type="warning"
          show-icon
          closable
          onClose={onClose}
        ></a-alert>
      )
    }
  },
})
